import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Roadmap = () => {
  const phases = [
    {
      year: "Sacred Burn I-III",
      items: [
        { text: "May 1: Full Moon (7.7M Burn)", done: true },
        { text: "May 16: New Moon (7.7M Burn)", done: true },
        { text: "May 31: Blue Full Moon (7.7M Burn)", done: true }
      ]
    },
    {
      year: "Sacred Burn IV-VII",
      items: [
        { text: "June 14: New Moon (7.7M Burn)", done: true },
        { text: "June 29: Full Moon (7.7M Burn)", done: true },
        { text: "July 14: New Moon (7.7M Burn)", done: true },
        { text: "July 29: Full Moon (7.7M Burn)", done: true }
      ]
    },
    {
      year: "The Solar Eclipse",
      items: [
        { text: "Aug 12: Double Burn (15.4M)", done: true },
        { text: "Final Treasury Reduction (22%)", done: true },
        { text: "Ecosystem Expansion", done: false }
      ]
    }
  ];

  return (
    <section className="py-32 px-4 relative">
      <div className="max-w-5xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold mb-6 text-white"
          >
            Temporal <span className="text-gradient">Burn Path</span>
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-slate-500 italic font-medium"
          >
            Verifiable on-chain through the Cryptogod444 wallet
          </motion.p>
        </div>

        <div className="space-y-16 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-1 before:bg-gradient-to-b before:from-purple-500 before:via-cyan-500 before:to-transparent before:opacity-30">
          {phases.map((phase, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active"
            >
              <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-[#030014] bg-gradient-to-br from-purple-500 to-cyan-500 text-white shadow-[0_0_20px_rgba(168,85,247,0.5)] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10">
                <SafeIcon name="Zap" className="w-5 h-5" />
              </div>

              <div className="w-[calc(100%-5rem)] md:w-[calc(50%-3rem)] glass-panel p-8 rounded-[2rem] hover:border-purple-500/30 transition-colors">
                <h3 className="font-extrabold text-2xl text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-cyan-400 mb-6 uppercase tracking-tighter">{phase.year}</h3>
                <ul className="space-y-4">
                  {phase.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-4">
                      {item.done ? (
                        <div className="p-1 rounded-full bg-green-500/20 text-green-400 shrink-0 mt-0.5">
                          <SafeIcon name="Check" className="w-4 h-4" />
                        </div>
                      ) : (
                        <div className="w-6 h-6 rounded-full border-2 border-slate-700 shrink-0 mt-0.5" />
                      )}
                      <span className={`text-lg ${item.done ? 'text-slate-200' : 'text-slate-500'}`}>{item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-24 text-center"
        >
          <div className="relative inline-block group">
            <div className="absolute -inset-1 bg-gradient-to-r from-pink-500 to-purple-600 rounded-2xl blur opacity-25 group-hover:opacity-75 transition duration-1000 group-hover:duration-200"></div>
            <a 
              href="https://daikholimited.etsy.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="relative flex items-center gap-4 px-12 py-6 bg-black rounded-2xl border border-white/10 text-white transition-all duration-300 hover:scale-105"
            >
              <SafeIcon name="ShoppingBag" className="w-6 h-6 text-pink-400" />
              <div className="text-left">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">Shop the Collection</p>
                <p className="text-xl font-bold">DKL Spiritual Merch</p>
              </div>
              <SafeIcon name="ArrowRight" className="w-5 h-5 ml-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Roadmap;